import React, { useState } from "react";
import styles from "../Dashboard.module.scss";
import OpenInIcon from "../../../../assets/images/open_in_new.svg";
import AddNewTaskModal from "./modals/AddNewTaskModal";
import MyTasks from "./MyTask";
import AdminTask from "./AdminTask";
import constants from "../../../../constants";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getStorage, setStorage } from "utils";
import { Tooltip } from "reactstrap";
import { withTranslation } from "react-i18next";
import Separator from "assets/images/Separator.svg";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";

const Tasks = ({
  appliedOfficeFilters,
  appliedStaffFilters,
  selectedOwner,
  isSchedulerOnly,
  t,
  isTaskFeatureEnabled,
  isFromDashboard,
  isStaff,
  isOwner,
}) => {
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editTaskId, setEditTaskId] = useState(null);
  const [tooltipEditOpen, setTooltipEditOpen] = useState(false);
  const isArchive = false;
  const [showDetail, setShowDetail] = useState(false);
  const closeModalHandler = () => {
    setIsModalOpen(false);
    setEditTaskId(null);
  };
  const [activeTabForStaff, setActiveTabForStaff] = useState(() => {
    const value = getStorage(constants.tasks.cache.taskslisting)?.activeTab;
    return value ? +value : 1;
  });
  const handleRedirect = (e) => {
    if (e.target.closest(".interactive-element")) {
      return;
    }
    history.push(constants.routes.taskManagements.taskManagement);
    setStorage("isChatFromDashBoard", true);
  };
  const { dataAccessValues } = useAccountOwnerCommon();

  return (
    <>
      <div
        className={
          styles.notes_tab_wrapper + " " + styles.border_top_left_right
        }
      >
        <div className={`p-3 ${styles.header_wrapper}`}>
          <p className={styles.task_heading}>{t("dashBoard.tasks")}</p>
          <div className="d-flex align-items-center gap-sm">
            {isTaskFeatureEnabled && (
              <>
                {(isOwner ||
                  (isStaff &&
                    dataAccessValues?.isAdmin &&
                    +activeTabForStaff === 2)) && (
                  <>
                    <button
                      className={styles["add-chat-button"]}
                      onClick={() => {
                        setIsModalOpen(true);
                      }}
                    >
                      <img
                        src={
                          require("assets/images/plus-icon-outline.svg").default
                        }
                        alt="icon"
                      />
                    </button>
                    <img src={Separator} alt="separator" />
                  </>
                )}
                <div onClick={handleRedirect} id="task_tooltip">
                  <img src={OpenInIcon} alt="open-icon" />
                </div>
                <Tooltip
                  isOpen={tooltipEditOpen}
                  placement="left"
                  target="task_tooltip"
                  toggle={() => {
                    setTooltipEditOpen(!tooltipEditOpen);
                  }}
                >
                  {t("dashBoard.gotoTasks")}
                </Tooltip>
              </>
            )}
          </div>
        </div>
      </div>
      {isOwner ? (
        <div
          className={`${styles.task_card_container_staff} ${
            showDetail ? "m-0 h-100" : ""
          }`}
          id="scrollableDivTwo"
        >
          <MyTasks
            isArchive={isArchive}
            appliedOfficeFilters={appliedOfficeFilters}
            appliedStaffFilters={appliedStaffFilters}
            selectedOwner={selectedOwner}
            handleRedirect={handleRedirect}
            isSchedulerOnly={isSchedulerOnly}
            showDetail={showDetail}
            setShowDetail={setShowDetail}
            isFromDashboard={isFromDashboard}
            setEditTaskId={(id) => {
              if (id) {
                setEditTaskId(id);
                setIsModalOpen(true);
              }
            }}
          />
        </div>
      ) : (
        <AdminTask
          isArchive={isArchive}
          appliedOfficeFilters={appliedOfficeFilters}
          appliedStaffFilters={appliedStaffFilters}
          selectedOwner={selectedOwner}
          handleRedirect={handleRedirect}
          isSchedulerOnly={isSchedulerOnly}
          showDetail={showDetail}
          setActiveTabForStaff={setActiveTabForStaff}
          setShowDetail={setShowDetail}
          isFromDashboard={isFromDashboard}
          setEditTaskId={(id) => {
            if (id) {
              setEditTaskId(id);
              setIsModalOpen(true);
            }
          }}
        />
      )}
      {isModalOpen && (
        <AddNewTaskModal
          isModalOpen={isModalOpen}
          editTaskId={editTaskId}
          setIsModalOpen={setIsModalOpen}
          closeModalHandler={closeModalHandler} // Add this prop to handle closing
        />
      )}
    </>
  );
};

export default withTranslation()(Tasks);
